import React, { useEffect } from 'react'
import {Grid, Typography, Button, Checkbox} from '@mui/material';
import colors from '../../../../../colors'
import SingleInvoice from '../../SingleInvoice'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useDispatch, useSelector } from 'react-redux';
import {sendGeneralRequest} from '../../../../../../features/generalRequest'
import { displayMainUtilityView, selectVodafoneInvoicesState, setIsTransactionSuccessfullyStarted, changeConfirmationDialogState } from '../../../../../../features/vodafone/vodafoneInvoicesSlice';
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice';
import { selectBasicAccountState, setShouldBasicAccountPaymentRun , setTransactionIdToCancel } from '../../../../../../features/basicAccount/basicAccountSlice';
import { runBasicAccountPayment } from '../../../../../general/BasicAccountMethods';
import ConfirmationDialog from '../../../../../general/ConfirmationDialog'
import HtmlTooltip from '../../../../../general/HtmlTooltip';
import { texts } from '../../../../../general/texts';
import { useLocation } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
          width: "10px",
          height:"50%",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: '#FFFFFF',
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
          borderRadius: "10px",
          maxHeight:'50%'
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        },
          maxHeight:'53vh',
          overflow:'auto',
          paddingLeft:'6%',
          marginTop:'1%',
          '@media (max-width: 899px )' : {height:'80%'}
      }
  }));

const VodafoneInvoiceListMultiSelect = (props) => 
{
    const userInfo = useSelector(selectUserInfo)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const dispatch = useDispatch()
    const classes = useStyles();
    const vodafoneInvoicesSliceState = useSelector(selectVodafoneInvoicesState)
    const [isFirstInvoiceSelected, setIsFirstInvoiceSelected] = React.useState(false)
    const location = useLocation();
    const [state, setState] = React.useState({
        token: props.globalDataSliceState.token,
        customerName: props.vodafoneInvoicesSliceState.customerName,
        searchType: props.vodafoneInvoicesSliceState.searchType,
        searchValue: props.vodafoneInvoicesSliceState.searchValue,
        serials: [],
        totalSum: 0
    })

    const handleCheckboxChange = (data, event) =>
    {    
        const serial = data['Seriali'];
        const value = data['Vlera'];
        setState({
            ...state,
            serials : (state.serials.includes(serial) 
                ? state.serials.filter((f) => f !== serial)
                : [...state.serials, serial]),
            totalSum: (state.serials.includes(serial) 
                ? state.totalSum - value
                : state.totalSum + value)
        })
    }  

    const handleBackButton = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
        setState({...state, serials:[], totalSum: 0})
    }

    const handleConfirmation = () => 
    {
        dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.vodafoneInvoicesSliceState.transactionId }, baseUrlKey:'services', endpoint: 'ASBS/ConfirmVodafoneInvoices'}))
    }

    React.useEffect(()=>{
        state.serials.includes(props.invoices[0].detailedInfo['Seriali']) 
            ? setIsFirstInvoiceSelected(true) 
            : setIsFirstInvoiceSelected(false)

            if(props.vodafoneInvoicesSliceState.isTransactionSuccessfullyStarted)
            {
                if(userInfo.accountType === 3)
                {
                    dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2',applicationID:1, value: Number(state.totalSum), transID: props.vodafoneInvoicesSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                    dispatch(setTransactionIdToCancel(props.vodafoneInvoicesSliceState.transactionId))
                }
                else
                {
                      dispatch(changeConfirmationDialogState())   
                }              
                dispatch(setIsTransactionSuccessfullyStarted(false))
            }
        
    },[state.serials, props.vodafoneInvoicesSliceState.isTransactionSuccessfullyStarted])

    useEffect(() => {
        const handleLocationChange = () => {
            dispatch(setShouldBasicAccountPaymentRun(false));
        };
    
        handleLocationChange(); // Initial call to handle location on mount
    
        return () => {
            handleLocationChange(); // Call on unmount
        };
    }, [location, dispatch]);

    return(
        <Grid container p={2.4}>
            {
            basicAccountSliceState.shouldBasicAccountPaymentRun 
                ? 
                runBasicAccountPayment(
                        dispatch,
                        basicAccountSliceState.basicAccountPaymentUrl,
                        {request: {token: props.globalDataSliceState.token, transID: props.vodafoneInvoicesSliceState.transactionId }, baseUrlKey:'services', endpoint: 'ASBS/ConfirmVodafoneInvoices'},
                        {request: {token: props.globalDataSliceState.token, orderId: props.vodafoneInvoicesSliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                        handleBackButton
                     ) 
                :
            <>
            <Grid container pt={3} pb={2}>
                <Grid container item md={1.5} xs={3} justifyContent={'left'} alignContent={'center'}  ><Button onClick={()=> {dispatch(displayMainUtilityView())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                <Grid container item md={10} xs={8} justifyContent={'left'} alignContent={'center'}  ><Typography sx={{fontWeight:'bold', color:colors.darkBlue}} variant='h5'>{texts["title-obligations-list"]} </Typography></Grid>
            </Grid>
            <Grid item container md={12} xs={12} pl={'4%'} pb={'3%'}>
                <Typography sx={{color:colors.darkBlue}} variant='h6'>{texts["dialog-gross-amount"]}: {Math.abs(state.totalSum).toFixed(2)} {texts["currency"]} </Typography>
            </Grid>
            <Grid item container className={classes.scrollBar} maxHeight= {'53vh'} overflow= {'auto'} md={12} xs={12}>
                <List className={classes.root}  >
                    {props.invoices.length > 0 &&  <Grid container item md={12} xs={12}>
                        <Grid md={9} xs={9} item>
                            <SingleInvoice utilityInfo={props.utilityInfo} contractData={props.invoices[0].displayInfo} isMultiSelect={true}/>
                        </Grid>
                        <Grid container md={1} xs={1} item>                                
                            <HtmlTooltip invoiceDetails={props.invoices[0].detailedInfo}/>
                        </Grid>
                        <Grid pt={'3.85%'} md={2} xs={1} item>
                            <Checkbox color='warning' sx={{":hover":{background:colors.white}}} contractData={props.invoices[0]} onChange={(e) => handleCheckboxChange(props.invoices[0].detailedInfo, e)}/>
                        </Grid>                   
                    </Grid>    
                }
                
                    {props.invoices.length > 0 && props.invoices.slice(1).map((invoice, index) => {
                        return <Grid container item md={12} xs={12} key={index} >
                                    <Grid md={9} xs={9} item>
                                        <SingleInvoice  utilityInfo={props.utilityInfo} contractData={invoice.displayInfo} isMultiSelect={true}/>
                                    </Grid>
                                    <Grid container md={1} xs={1} item>                                
                                        <HtmlTooltip invoiceDetails={invoice.detailedInfo}/>
                                    </Grid>
                                    <Grid pt={'3.85%'} md={2} xs={1} item>
                                        <Checkbox disabled={isFirstInvoiceSelected ? false : true} color='warning' sx={{":hover":{background:colors.white}}} contractData={invoice} onChange={(e) => handleCheckboxChange(invoice.detailedInfo, e)}/>
                                    </Grid>
                    
                                </Grid>
                    })}    
                </List>
                                          
            </Grid>
            <Grid container item justifyContent={'center'} pt={'4%'} md={12}>
                <Button onClick={()=>{dispatch(sendGeneralRequest({request: {...state, totalSum: String(state.totalSum)}, baseUrlKey:'services', endpoint: 'ASBS/StartVodafoneInvoices'}))}} disabled={!isFirstInvoiceSelected || vodafoneInvoicesSliceState.isLoading ? true : false} sx={{background:colors.gradientOrange ,width:'100%', color:colors.white, fontFamily:'GerberaBold'}}>{texts["title-pay"]}</Button>        
            </Grid>
            {props.vodafoneInvoicesSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={props.vodafoneInvoicesSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
            </>
        }  
        </Grid>   
    )
}
export default VodafoneInvoiceListMultiSelect
